/* EasySell COD button — theme integration.

   1. Restyle. The app injects <div class="es-popup-button"> with inline !important
      styles, which a stylesheet can never override. This strips those inline styles,
      adds .cod-btn classes, swaps the icon-font glyph for the theme SVG and splits
      "Order Now - Cash on Delivery" into a title and subtitle for cod-button.css.
   2. Cover late cards. The app scans the page once, at load, and attaches a click
      listener to each button it creates. Cards rendered afterwards (product
      recommendations, "load more") therefore never get a button. For every card
      add-to-cart form still without one, a proxy button is added; on click it briefly
      moves a real app button into that form, clicks it (the app reads the variant from
      the button's closest form) and puts it back. With no app button on the page it
      falls back to the product page. */
(function () {
  var root = document.documentElement;
  if (root.dataset.codButtonStyle === 'app') return;

  var LARGE_CONTEXT = 'product-info, .product__info-wrapper, .product-form, .product__info-container, .cart__ctas, .drawer__footer, .cart__footer';
  var SPLIT = /\s+(?:-|–|—|\||·)\s+/;
  // Banknote outline, 1.25 stroke — same icon snippets/cod-button-link.liquid renders.
  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<rect x="2.5" y="6.5" width="19" height="11"/>' +
    '<circle cx="12" cy="12" r="2.6"/>' +
    '<path d="M6.25 10.75v2.5M17.75 10.75v2.5"/>' +
    '</svg>';

  // Replace the app's Bootstrap icon-font glyph with the theme's inline SVG.
  function swapIcon(el) {
    var glyph = el.querySelector('.bi');
    if (!glyph || el.querySelector('.cod-btn__icon')) return;
    var icon = document.createElement('span');
    icon.className = 'cod-btn__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = ICON;
    glyph.replaceWith(icon);
  }

  function splitTitle(el) {
    var title = el.querySelector('.es-button-title');
    if (!title || title.dataset.codSplit === '1') return;
    title.dataset.codSplit = '1';
    var text = (title.textContent || '').trim();
    var parts = text.split(SPLIT);
    title.classList.add('cod-btn__text');
    title.textContent = '';
    var main = document.createElement('span');
    main.className = 'cod-btn__title';
    main.textContent = parts[0];
    title.appendChild(main);
    if (parts.length > 1) {
      var sub = document.createElement('span');
      sub.className = 'cod-btn__sub';
      sub.textContent = parts.slice(1).join(' ');
      title.appendChild(sub);
    }
  }

  function restyle(el) {
    if (el.dataset.codStyled !== '1') {
      el.dataset.codStyled = '1';
      el.removeAttribute('style');
      el.classList.add('cod-btn', el.closest(LARGE_CONTEXT) ? 'cod-btn--pdp' : 'cod-btn--card');
    }
    // Wrapper divs/spans carry inline margins and font styles; the spinner <i> keeps its display:none.
    el.querySelectorAll('div, span').forEach(function (child) {
      child.removeAttribute('style');
    });
    swapIcon(el);
    splitTitle(el);
  }

  // ---- Proxy buttons for cards the app never saw -------------------------------

  var CARD_FORM = 'form[action*="/cart/add"][data-type="add-to-cart-form"]';
  var CARD_SLOT = '.custom-product-slider__quick-add, .nayelle-recommendations__quick-add, .nayelle-card__quick-add, .card__content .quick-add, .quick-add';
  var appReady = false;

  // The label the app is currently using, so theme-rendered buttons always match it.
  function liveLabel() {
    var live = document.querySelector('.es-popup-button-product .cod-btn__title, .es-popup-button .cod-btn__title');
    if (!live) return null;
    var btn = live.closest('.es-popup-button');
    var sub = live.parentNode.querySelector('.cod-btn__sub');
    return {
      title: live.textContent.trim(),
      sub: sub ? sub.textContent.trim() : '',
      icon: !!(btn && btn.querySelector('.cod-btn__icon, .bi'))
    };
  }

  function proxyLabel() {
    var live = liveLabel();
    if (live && live.title) return live.title + (live.sub ? ' - ' + live.sub : '');
    var label = (root.dataset.codLabel || '').trim();
    return label || 'Order Now - Cash on Delivery';
  }

  // Copy the app's label and icon presence onto the theme's link and proxy buttons.
  function syncThemeButtons() {
    var live = liveLabel();
    if (!live || !live.title) return;
    document.querySelectorAll('.cod-btn--link, .cod-btn--proxy').forEach(function (btn) {
      var title = btn.querySelector('.cod-btn__title');
      var sub = btn.querySelector('.cod-btn__sub');
      var text = btn.querySelector('.cod-btn__text');
      var icon = btn.querySelector('.cod-btn__icon');
      if (title && title.textContent.trim() !== live.title) title.textContent = live.title;
      if (live.sub) {
        if (!sub && text) {
          sub = document.createElement('span');
          sub.className = 'cod-btn__sub';
          text.appendChild(sub);
        }
        if (sub && sub.textContent.trim() !== live.sub) sub.textContent = live.sub;
      } else if (sub) {
        sub.remove();
      }
      if (icon) icon.hidden = !live.icon;
    });
  }

  function buildProxy(form) {
    var parts = proxyLabel().split(SPLIT);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cod-btn cod-btn--card cod-btn--proxy';
    btn.dataset.codStyled = '1';
    var icon = document.createElement('span');
    icon.className = 'cod-btn__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = ICON;
    var text = document.createElement('span');
    text.className = 'cod-btn__text';
    var main = document.createElement('span');
    main.className = 'cod-btn__title';
    main.textContent = parts[0];
    text.appendChild(main);
    if (parts.length > 1) {
      var sub = document.createElement('span');
      sub.className = 'cod-btn__sub';
      sub.textContent = parts.slice(1).join(' ');
      text.appendChild(sub);
    }
    btn.appendChild(icon);
    btn.appendChild(text);
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      openWithForm(form, btn);
    });
    return btn;
  }

  function donorButton() {
    return document.querySelector('.es-popup-button-product:not(.cod-btn--proxy)') ||
      document.querySelector('.es-popup-button:not(.es-popup-button-cart):not(.es-popup-button-drawer):not(.cod-btn--proxy)');
  }

  function productUrlFor(form) {
    var host = form.closest('[data-product-url]');
    if (host && host.dataset.productUrl) return host.dataset.productUrl;
    var card = form.closest('article, li, .card-wrapper');
    var a = card && card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : null;
  }

  function openWithForm(form, proxy) {
    var donor = donorButton();
    if (!donor || !form.isConnected) {
      var url = productUrlFor(form);
      if (url) window.location.href = url;
      return;
    }
    var submit = form.querySelector('[type="submit"], [name="add"]') || form.lastElementChild;
    var origin = { parent: donor.parentNode, next: donor.nextSibling };
    proxy.classList.add('loading');
    proxy.setAttribute('aria-busy', 'true');
    try {
      // The app's handler reads event.target.closest('form[action*="/cart/add"]').
      if (submit) submit.insertAdjacentElement('afterend', donor);
      else form.appendChild(donor);
      donor.click();
    } finally {
      if (origin.parent) origin.parent.insertBefore(donor, origin.next);
      proxy.classList.remove('loading');
      proxy.removeAttribute('aria-busy');
    }
  }

  function needsProxy(form) {
    if (form.closest('#easysell-modal, cart-drawer, cart-notification, quick-add-modal, .quick-add-modal')) return false;
    var slot = form.closest(CARD_SLOT);
    if (!slot) return false;
    if (slot.querySelector('.es-popup-button, .cod-btn--proxy, .cod-btn--link')) return false;
    var submit = form.querySelector('[type="submit"], [name="add"]');
    return !!submit && !submit.disabled;
  }

  function addProxies(scope) {
    if (!appReady) return;
    var node = scope && scope.querySelectorAll ? scope : document;
    var forms = [];
    if (node.matches && node.matches(CARD_FORM)) forms.push(node);
    node.querySelectorAll(CARD_FORM).forEach(function (f) { forms.push(f); });
    forms.forEach(function (form) {
      if (!needsProxy(form)) return;
      var submit = form.querySelector('[type="submit"], [name="add"]');
      submit.insertAdjacentElement('afterend', buildProxy(form));
    });
  }

  // If the app injects a real button next to a proxy (it re-scans some cart contexts),
  // the proxy is redundant.
  function dropShadowedProxies(scope) {
    var node = scope && scope.querySelectorAll ? scope : document;
    node.querySelectorAll('.cod-btn--proxy').forEach(function (proxy) {
      var slot = proxy.closest(CARD_SLOT);
      if (slot && slot.querySelector('.es-popup-button')) proxy.remove();
    });
  }

  function markAppReady() {
    if (appReady) return;
    appReady = true;
    addProxies(document);
  }

  // EasySell calls this hook once its buttons are in place. Chain any existing hook.
  var previousHook = window.es_after_insertion_completed;
  window.es_after_insertion_completed = function () {
    if (typeof previousHook === 'function') previousHook.apply(this, arguments);
    markAppReady();
  };

  function armReadyFallback() {
    // The hook may already have fired before this script ran, or the app may be off.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (document.querySelector('.es-popup-button') || tries >= 12) {
        clearInterval(timer);
        setTimeout(markAppReady, document.querySelector('.es-popup-button') ? 300 : 0);
      }
    }, 500);
  }

  // The order form title carries "text-align:center !important; font-size:18px !important"
  // inline, which cod-button.css cannot override. Strip it and let the stylesheet lay it out.
  var FORM_TITLE = '#easysell-modal .es-form-header .flex-fill > div';

  function restyleFormTitle(el) {
    el.dataset.codStyled = '1';
    if (el.getAttribute('style')) el.removeAttribute('style');
  }

  function scan(scope) {
    var node = scope && scope.querySelectorAll ? scope : document;
    if (node.classList && node.classList.contains('es-popup-button')) restyle(node);
    node.querySelectorAll('.es-popup-button').forEach(restyle);
    var inner = node.closest && node.closest('.es-popup-button');
    if (inner) restyle(inner);
    if (node.matches && node.matches(FORM_TITLE)) restyleFormTitle(node);
    node.querySelectorAll(FORM_TITLE).forEach(restyleFormTitle);
    dropShadowedProxies(node);
    addProxies(node);
    syncThemeButtons();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes') {
        // The app re-applied its inline style (e.g. hover animation). Strip it again.
        if (m.target.dataset.codStyled === '1' && m.target.getAttribute('style')) {
          m.target.removeAttribute('style');
        }
        return;
      }
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) scan(n);
      });
    });
  });

  function start() {
    scan(document);
    if (document.readyState === 'complete') armReadyFallback();
    else window.addEventListener('load', armReadyFallback, { once: true });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
